export const appConfig = {
  JWT_KEY: "accessToken",
  USER_KEY: "user",
  PASSWORD_KEY: "password",
  PAGE_SIZE: 10,
};
